// extracted by mini-css-extract-plugin
export default {"col_w1000":"index_col_w1000_urmoo"};